import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from "@material-ui/icons/Done";
import EditIcon from "@material-ui/icons/Edit";
import EmailIcon from "@material-ui/icons/Email";
import TaskAddIcon from "@material-ui/icons/PlaylistAdd";
import SearchIcon from "@material-ui/icons/Search";
import arraysort from "array-sort";
import React, { useEffect, useState } from "react";
import { getLoggedInUserTenantID } from "../apis/sessionUtil";
import {
  addTask, deleteTask, getTasks, getTasksForProcessId,
  sendSubmissionsRequestEmails,
  updateTask
} from "../apis/tasks";
import { SORT_DIRECTION, STATUS } from "../constants";
import AddEmail from "./AddEmail";
import { CreateTaskForm } from "./CreateTaskForm";
import "./dnd.css";
import { LightTooltip } from "./LightTooltip";
import Loading from "./Loading";
import useStyles from "./muistyles";
import "./GenericReusableComponents/table.css";
import {Table} from "./GenericReusableComponents/Table"
import {TButton} from "./GenericReusableComponents/HTMLWrappers"



export default function TaskMgmt(props) {
  const headerInfo = {
    "Task Name": {
      fieldName: "taskName",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Business Name for a Task",
    },
    "Description": {
      fieldName: "description",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Business Description for Task",
    },
    "End Date": {
      fieldName: "endDate",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Task Recording Completion Date",
    },
    "Priority": {
      fieldName: "priority",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Business Priority for Task",
    },

    "User Count": {
      fieldName: "userCount",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Total users working on Task",
    },
    "Cost Per Hour": {
      fieldName: "costperhour",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Cost paid per hour to a worker on Task",
    },
    "Status": {
      fieldName: "status",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Task Status",
    },
    "Actions": {
      toolTip: "Invite Submissions, Manage Tasks",
    },
  };

  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [q, setQ] = useState("");
  const [showAddEmail, setShowAddEmail] = useState(false);
  // const [showAddTaskForm,setShowAddTaskForm] = useState(false);
  // const [showDelTaskModal,setShowDelTaskModal] = useState(false);
  const [showAddTaskForm, setShowAddTaskForm] = useState(false);
  const [currentTask, setCurrentTask] = useState({});
  const [showUpdtTaskModal, setShowUpdtTaskModal] = useState(false);
  const [tasksChanged, setTasksChanged] = useState(false);
  const [selEmailTask, setSelEmailTask] = useState("");
  const [loading, setLoading] = useState(true);
  const [sortDirection, setSortDirection] = useState(SORT_DIRECTION.DESC.value);
  const [sortHeader, setSortHeader] = useState("Task Name");
  const [headerFieldMap,setHeaderFieldMap] = useState(headerInfo);
  const iconButtonStyle = {
    color: "slateblue",
    color: "black",
    // fontFamily: "Arial, Helvetica, sans-serif",
    // fontFamily: "Century",
    fontSize: "1em",
    fontWeight: "bold",
  };

  const classes = useStyles();


  useEffect(() => {
    // console.log("Inside useEffect TaskMgmt");
    let mounted = true;

    // getTasks().then((tasks) => {
    console.log(props.processId)
    getTasksForProcessId(props.processId).then((tasks) => {
      // console.log("display Tasks");
      // console.log(tasks.data);
      
      if (mounted) {
        
          setTasks(arraysort(tasks.data, "taskName"));
          var ftasks = [];
          tasks.data.forEach((x) => ftasks.push(x));
          setFilteredTasks(ftasks);
          setTasksChanged(false);
          setLoading(false);
      }
    });
    return () => {
      // console.log("TaskMgmt is unmounted");
      mounted = false;
    };
  }, [tasksChanged]);

 

  

  function toggleSortDirection() {
    if (sortDirection === SORT_DIRECTION.DESC.value) {
      setSortDirection(SORT_DIRECTION.ASC.value);
    } else {
      setSortDirection(SORT_DIRECTION.DESC.value);
    }
  }

  function filterTable(filterString) {
    console.log(filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredTasks(tasks);
      setQ("");
    } else {
      setQ(filterString);
      setFilteredTasks(
        tasks.filter((task) => {
          if (task.taskName.startsWith(filterString)) return true;

          if (task.description.startsWith(filterString)) return true;

          if (task.priority.startsWith(filterString)) return true;

          if (task.status.startsWith(filterString)) return true;

          console.log("no match ");
          console.dir(task);
        })
      );
    }
  }

  function setTasksChangedTrigger(bool) {
    console.log("settasksChanged " + bool);
    setTasksChanged(bool);
  }

  function handleAddTask() {
    console.log("handleAddTask");
    setShowAddTaskForm(true);
  }

  function onSend(task, emails) {
    console.log(getLoggedInUserTenantID());
    console.log(task.taskName);
    console.log(emails);
    sendSubmissionsRequestEmails(task, emails);
  }

  function emailTask(e, task) {
    setSelEmailTask(task);
    setShowAddEmail(true);
  }

  //temporarily duplicating the code. reuse later
  function getStatusStyle(status) {
    var statusStyle = "status";
    switch (status) {
      case "INACTIVE":
        statusStyle = statusStyle + " statusInactive";
        break;
      case "DISABLED":
        statusStyle = statusStyle + " statusDisabled";
        break;

      default:
        statusStyle = statusStyle + " statusActive";
    }
    return statusStyle;
  }

  function updateTasksState(task) {
    let ltasks = [...filteredTasks];
    let i = ltasks.findIndex((t) => t.taskId === task.taskId);
    ltasks[i] = { ...task };
    setFilteredTasks(ltasks);
    setTasks(ltasks);
  }

  function handleClickOnEdit(task) {
    task.makeRowEditable = true;
    task.update = true;
    setCurrentTask({ ...task });
  }
  function update(task) {
    let ltask = { ...currentTask };
    ltask.makeRowEditable = false;
    task.update = false;
    updateTasksState(ltask);
    updateTask(ltask)
      .then(res => { return res.json()})
      .then(data => {
        console.log("Update Task successful")
        console.log(JSON.stringify(data));
        setCurrentTask({});
        setTasksChanged(true);
        setLoading(true);
      })
      .catch((err) => {
        console.error(err.message);
        throw err;
      });

    
  }

  function cancel(task) {
    let ltask = { ...task };
    ltask.makeRowEditable = false;
    task.update = false;
    updateTasksState(ltask);
    setCurrentTask({});
  }

 

  function getCostPerHour(task) {
    if (task.makeRowEditable) {
      return (
        <TextField
          id="costperhour"
          defaultValue={task.costperhour}
          style={{ width: "30px" }}
          onChange={(e) => {
            currentTask.costperhour = parseInt(e.target.value,10);
          }}
        />
      );
    } else {
      return task.costperhour;
    }
  }

  function getUserCount(task) {
    if (task.makeRowEditable) {
      return (
        <TextField
          id="userCount"
          style={{ width: "30px" }}
          defaultValue={task.userCount}
          onChange={(e) => {
            currentTask.userCount = parseInt(e.target.value,10);
          }}
        />
      );
    } else {
      return task.userCount;
    }
  }

  function getPriority(task) {
    if (task.makeRowEditable) {
      return (
        <Select
          name="priority"
          defaultValue={task.priority}
          onChange={(e) => {
            currentTask.priority = e.target.value;
          }}
        >
          <MenuItem value="CRITICALAL">CRITICALAL</MenuItem>
          <MenuItem value="HIGH">HIGH</MenuItem>
          <MenuItem value="MEDIUM">MEDIUM</MenuItem>
          <MenuItem value="LOW">LOW</MenuItem>
        </Select>
      );
    } else {
      return task.priority;
    }
  }

  function getEndDate(task) {
    if (task.makeRowEditable) {
      return (
        <TextField
          type="date"
          id="date"
          defaultValue={task.endDate}
          style={{ width: "150px" }}
          onChange={(e) => {
            currentTask.endDate = e.target.value;
          }}
        />
      );
    } else {
      return task.endDate;
    }
  }

  function getTaskName(task) {
    if (task.makeRowEditable) {
      return (
        <TextField
          id="taskName"
          defaultValue={task.taskName}
          style={{ width: "150px" }}
          onChange={(e) => {
            currentTask.taskName = e.target.value;
          }}
        />
      );
    } else {
      return task.taskName;
    }
  }

  function getDescription(task) {
    if (task.makeRowEditable) {
      return (
        <TextField
          id="taskDescription"
          defaultValue={task.description}
          onChange={(e) => {
            currentTask.description = e.target.value;
          }}
        />
      );
    } else {
      return task.description;
    }
  }

  function handleClickOnDelete(task) {
    task.markTobeDeleted = true;
    updateTasksState(task);
  }

  function handleDeleteTask(task) {
    deleteTask(task)
      .then((res) => {
        return res.json();      
      })
      .then((data) =>{
        console.log("Delete Task Succesfull");
        console.log(JSON.stringify(data));
        setTasksChanged(true);
        setLoading(true);
      } )
      .catch((err) => {
        console.log(err.message)
        throw err;
      });
  }

  function handleCancelDelete(task) {
    task.markTobeDeleted = false;
    updateTasksState(task);
  }

  function add(task) {
    let ltask = { ...currentTask };
    ltask.addnew = false;
    ltask.makeRowEditable = false;

    let itask = {};
    itask.taskName = ltask.taskName;
    itask.description = ltask.description;
    itask.endDate = ltask.endDate;
    itask.priority = ltask.priority;
    itask.userCount = ltask.userCount;
    itask.costperhour = ltask.costperhour;
    itask.status = STATUS.ACTIVE.string;

    addTask(itask, props.processId)
      .then((res) => {
        console.log(res.json());
        let ltasks = [...tasks];

        let i = ltasks.findIndex((t) => t.addnew === true);

        ltasks[i] = { ...itask };
        setTasks(ltasks);
        setFilteredTasks(ltasks);
        setTasksChanged(true);
      })
      .catch((err) => console.log(err.message));
  }

  function cancelAdd(task) {
    let ltasks = [...tasks];

    let i = ltasks.findIndex((t) => t.addnew === true);
    ltasks.splice(i, 1);

    setTasks(ltasks);
    setFilteredTasks(ltasks);
  }

  function getActions(task) {
    if (task.markTobeDeleted) {
      return (
        <div className='tableActions'>
          <LightTooltip title="Confirm">
            <IconButton onClick={() => handleDeleteTask(task)}>
              <DeleteIcon />
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Cancel">
            <IconButton onClick={() => handleCancelDelete(task)}>
              <CloseIcon />
            </IconButton>
          </LightTooltip>
        </div>
      );
    }

    if (task.addnew && task.makeRowEditable) {
      return (
        <div className='tableActions'>
          <LightTooltip title="Add">
            <IconButton onClick={() => add(task)}>
              <AddIcon />
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Cancel">
            <IconButton onClick={() => cancelAdd(task)}>
              <CloseIcon />
            </IconButton>
          </LightTooltip>
          </div>
      );
    }
    if (task.update && task.makeRowEditable) {
      return (
        <div className='tableActions'>
          <LightTooltip title="Update">
            <IconButton onClick={() => update(task)}>
              <DoneIcon />
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Cancel">
            <IconButton onClick={() => cancel(task)}>
              <CloseIcon />
            </IconButton>
          </LightTooltip>
          </div>
      );
    } else {
      return (
        <div className='tableActions'>
          <LightTooltip title="Email Invites for Task Recording Submissions">
            <IconButton className="toolbutton" onClick={(e) => emailTask(e, task)}>
              <EmailIcon className ='roundButton'></EmailIcon>
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Edit Task">
            <IconButton className="toolbutton" onClick={() => handleClickOnEdit(task)}>
              <EditIcon className ='roundButton'></EditIcon>
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Delete Task">
            <IconButton className="toolbutton" onClick={() => handleClickOnDelete(task)}>
              <DeleteIcon className ='roundButton'></DeleteIcon>
            </IconButton>
          </LightTooltip>
          </div>
      );
    }
  }

  
  function sortBy(headerName, sortDirection) {
    console.log("Called sortby");
    let ltasks = [...tasks];
    let lheaderInfo = {...headerFieldMap};
    lheaderInfo[headerName].sortDirection = sortDirection; //this is the current sort direction now.
    setHeaderFieldMap(lheaderInfo);
    console.log(headerName);
    console.log(headerFieldMap[headerName].fieldName);
    arraysort(ltasks, headerFieldMap[headerName].fieldName, {
      reverse: headerFieldMap[headerName].sortDirection,
    });
    setSortHeader(headerName);
    setTasks(ltasks);
    setFilteredTasks(ltasks);
  }

  function getHeader(headerName) {
  

    if(headerName == "Actions"){
      return(
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th>{headerName}</th>
        </LightTooltip>
      )
    }
    if (headerName != sortHeader) 
      return (
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th
            onClick={() =>
              sortBy(headerName, getFutureSortDirection(headerName))
            }
          >
            {headerName}
          </th>
        </LightTooltip>
      );
    

    //headerName is sortHeader
    if (headerFieldMap[headerName].sortDirection === SORT_DIRECTION.ASC.value) {
      return (
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th
            onClick={() =>
              sortBy( headerName , getFutureSortDirection( headerName ))
            }
          >
            <IconButton size="small" style={iconButtonStyle}>
              {headerName}
              <ArrowUpwardIcon />
            </IconButton>
          </th>
        </LightTooltip>
      );
    } else {
      return (
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th
            onClick={() =>
              sortBy(headerName, getFutureSortDirection(headerName))
            }
          >
            <IconButton size="small" style={iconButtonStyle}>
              {headerName}
              <ArrowDownwardIcon />
            </IconButton>
          </th>
        </LightTooltip>
      );
    }
  }

  function getFutureSortDirection(headerName) {
    if (headerFieldMap[headerName].sortDirection === SORT_DIRECTION.ASC.value) {
      return SORT_DIRECTION.DESC.value;
    } else {
      return SORT_DIRECTION.ASC.value;
    }
  }

  function getTableActions(){
    return(
         <Button
          variant="contained"
          color="primary"
          onClick={handleAddTask}
          className={classes.button }
          startIcon={<TaskAddIcon fontSize="inherit" />}
        >
          Add Task
        </Button>

      // <TButton 
      //   toolTip="Add Task"
      //   text="Add Task"
      //   onClick={handleAddTask}
      //   startIcon={<TaskAddIcon fontSize="inherit" />}
      // />
    )

  }

  function getTableHeader(){

    return (

           <tr>
            {Object.keys(headerFieldMap).map((headerName) => (
              <>{getHeader(headerName)}</>
            ))}

          </tr>
    )

  }

  function getTableBody(){
    return (
      <>
           {filteredTasks.map((task) => (
            <tr>
              <td>{getTaskName(task)}</td>
              <td>{getDescription(task)}</td>
              <td>{getEndDate(task)}</td>
              <td>{getPriority(task)}</td>
              <td>{getUserCount(task)}</td>
              <td>{getCostPerHour(task)}</td>
              <td>
                <span className={getStatusStyle(task.status)}>
                  {task.status}
                </span>
              </td>
              <td>{getActions(task)}</td>
            </tr>
          ))}
        </>
    )
  }

return (
   <div>
      {/* <p/>
      <label style={{padding:'5px', backgroundColor:'#bababa', color:'white', fontSize:'18px'}}>{props.processName}</label>
      <p/> */}
      <Table
        search={filterTable}
        tableActions={getTableActions()} 
        columns={getTableHeader()} 
        rows={getTableBody()}
        loading={loading}
        tbcontainerstyle={{margin:'0px',padding:'0px'}}
      />

      <AddEmail
        task={selEmailTask}
        onSend={onSend}
        show={showAddEmail}
        setShow={setShowAddEmail}
      />

      <CreateTaskForm
        processId = {props.processId}
        setShow={setShowAddTaskForm}
        show={showAddTaskForm}
        setTasksChangedTrigger={setTasksChangedTrigger}
      />
      </div>
   
     
   
  );
}
